<template>
  <custom-dialog class="event-item-dialog" width="1400px" :title="title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules">
        <div class="content">
          <div class="event-msg">
            <div class="title">{{ $t('dms_event_item_dialog.shi_jian_xin_xi') }}</div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('dms_event_item_dialog.shi_jian_lei_bie')" prop="eventClass">
                  <custom-select placeholder="" code="iot_event_class" v-model="form.eventClass"></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_event_item_dialog.shi_jian_deng_ji')" prop="eventLevel">
                  <custom-select placeholder="" code="iot_event_level" v-model="form.eventLevel"></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_event_item_dialog.xie_yi_lei_bie')" prop="protocolClass">
                  <custom-select v-model="form.protocolClass" code="iot_protocol_class" @change="protocolClassChange"></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_event_item_dialog.yu_zhong')" prop="langCode">
                  <custom-select placeholder="" code="language_type" v-model="form.langCode" @change="langCodeChange"></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_event_item_dialog.bu_jian_ming_cheng')" prop="componentCode">
                  <custom-select
                    @getList="componentCodeGetList"
                    :auto="false"
                    ref="componentCode"
                    v-model="form.componentCode"
                    filterable
                    url="eventComponentListByProtocolClass"
                    :params="{ protocolClass: form.protocolClass, langCode: form.langCode }"
                    :props="{ label: 'componentName', value: 'componentCode' }"
                  ></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_event_item_dialog.shi_jian_lei_xing')" prop="eventType">
                  <custom-select placeholder="" code="ice_open_event_type" v-model="form.eventType"></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_event_item_dialog.shi_jian_dai_ma')" prop="eventCode">
                  <custom-select
                    ref="eventCode"
                    v-model="form.eventCode"
                    url="eventTslCodeList"
                    :props="{ label: 'tslCode', value: 'tslCode' }"
                    :params="{ protocolClass: form.protocolClass }"
                    :auto="false"
                    :filterable="true"
                    allow-create
                    default-first-option
                    @change="eventCodeChange"
                  ></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_event_item_dialog.shi_jian_ming_cheng')" prop="eventName">
                  <el-input v-model="form.eventName"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('dms_event_item_dialog.HMIxian_shi')" prop="isHmiShow">
                  <el-switch v-model="form.isHmiShow" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('dms_event_item_dialog.HMIyan_se')" prop="hmiColor">
                  <custom-select placeholder="" code="iot_hmi_color" v-model="form.hmiColor"></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_event_item_dialog.HMIming_cheng')" prop="hmiName">
                  <el-input v-model="form.hmiName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('dms_event_item_dialog.HMIdai_maV3')" prop="hmiV3Code">
                  <el-input v-model="form.hmiV3Code"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_event_item_dialog.HMIdai_maV4')" prop="hmiV4Code">
                  <el-input v-model="form.hmiV4Code"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('dms_event_item_dialog.tui_song_xiao_xi')" prop="isPushMsg">
                  <el-switch v-model="form.isPushMsg" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_event_item_dialog.xie_zhu')" prop="isAssist">
                  <el-switch v-model="form.isAssist" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('Common.com_status')" prop="state">
                  <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('dms_event_item_dialog.shi_jian_zhu_tu')">
                  <t-upload type="text" :limit="1" :bizId="form.eventId" bizType="dms.event.icon" v-model="form.iconList" :autoUpload="false" ref="dmsEventIcon"></t-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_event_item_dialog.shi_jian_miao_shu')" prop="eventDesc">
                  <el-input type="textarea" v-model="form.eventDesc"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="handle-file">
            <div class="title">{{ $t('dms_event_item_dialog.chu_li_fang_an') }}</div>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_event_item_dialog.HMIxian_shi_chu_li')" prop="hmiDisposal">
                  <custom-editor v-model="form.hmiDisposal" :height="150" folder="isc/richtext/event"></custom-editor>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_event_item_dialog.HMIchu_li_fu_jian')">
                  <t-upload
                    accept="image/*,video/*"
                    type="file"
                    :limit="3"
                    :bizId="form.eventId"
                    bizType="dms.disposal.customer"
                    v-model="form.hmiMediaList"
                    :autoUpload="false"
                    ref="dmsDisposalCustomer"
                  ></t-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_event_item_dialog.shclfa')" prop="serviceDisposal">
                  <custom-editor v-model="form.serviceDisposal" :height="150" folder="isc/richtext/event"></custom-editor>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('dms_event_item_dialog.shclfj')">
                  <t-upload
                    accept="image/*,video/*"
                    type="file"
                    :limit="3"
                    :bizId="form.eventId"
                    bizType="dms.disposal.technician"
                    v-model="form.serviceMediaList"
                    :autoUpload="false"
                    ref="dmsDisposalTechnician"
                  ></t-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">
        {{ $t('Common.com_cancel') }}
      </el-button>
      <el-button type="primary" @click="onConfirm">
        {{ $t('Common.com_confirm') }}
      </el-button>
    </div>
  </custom-dialog>
</template>

<script>
import tUpload from '@/components/upload.vue';
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import customEditor from '@/components/customEditor';

export default {
  mixins: [dialogMixins],
  props: {
    // model: {
    //   data: { eventId }
    // }
  },
  components: { tUpload, customEditor },
  computed: {
    rules() {
      return {
        // 事件类别
        eventClass: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        // 事件类型      dic: 事件类型 - ice_open_event_type
        eventType: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        // 事件等级  dic: 事件等级 - iot_event_level
        eventLevel: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        // 产品型号
        productCode: { required: true, message: this.$t('Common.com_required') },
        // 部件
        componentCode: { required: true, message: this.$t('Common.com_required') },
        // 事件代码
        eventCode: { required: true, message: this.$t('Common.com_required') },
        // 客户代码
        // customerCode: { required: true, message: '必填项' },
        // 事件名称
        eventName: { required: true, message: this.$t('Common.com_required') },
        // 事件描述
        // eventDesc: { required: true, message: '必填项' },
        // 客户处理方案
        // hmiDisposal: { required: true, message: '必填项' },
        // 售后处理方案
        // serviceDisposal: { required: true, message: '必填项' },
        // 语种  dic:语种 - langCode
        langCode: { required: true, message: this.$t('Common.com_required') },
      };
    },
    title() {
      if (this.model.title) {
        return this.model.title;
      }
      return this.model.type === 'add' ? this.$t('dms_event_item_dialog.xzsjdm') : this.$t('dms_event_item_dialog.bjsjdm');
    },
  },
  data() {
    return {
      productQuery: {
        productCode: '',
      },
      componentSelectKey: Math.random(),
      curProductSn: '',
      // 部件列表
      componentCodeList: [],
      form: {
        protocolClass: '',
        // 事件类别     dic: 事件类别 - iot_event_class
        eventClass: '',
        // 事件类型      dic: 事件类型 - ice_open_event_type
        eventType: '',
        // 事件等级  dic: 事件等级 - iot_event_level
        eventLevel: '',
        // 事件主图 id
        eventIcon: '',
        iconList: [],

        // 产品型号
        productCode: '',
        // 部件名称
        componentName: '',
        componentCode: '',
        // 事件代码
        eventCode: '',
        // 客户代码
        customerCode: '',
        // 事件名称
        eventName: '',
        // 事件描述
        eventDesc: '',
        // 客户处理方案
        hmiDisposal: '',
        hmiName: '',
        // 客户处理附件 id
        customerMedia: '',
        hmiMediaList: [],

        // 售后处理方案
        serviceDisposal: '',
        // 售后处理附件 id
        serviceMedia: '',
        serviceMediaList: [],

        // 语种  dic:语种 - langCode
        langCode: '',
        // 是否通知  dic: 布尔值转换 - isynergy_cloud_bool
        isPushMsg: 0,
        // 状态  dic: 通用状态 - cloud_common_state
        state: 1,

        // HMI显示
        isHmiShow: 0,

        // V3代码
        hmiV3Code: '',
        // V4代码
        hmiV4Code: '',

        // 协助
        isAssist: 0,

        creator: '',
        creatorId: '',
        eventId: '',
        eventVal: '',
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    componentCodeGetList(list) {
      this.componentCodeList = list;
    },
    // 事件代码 可输入选择，也可以输入，如果是选择带出事件名称
    eventCodeChange(data) {
      if (data && data.tslName) {
        this.form.eventName = data.tslName;
      } else {
        this.form.eventName = '';
      }
    },
    updateEventCodeSel() {
      if (this.form.protocolClass) {
        setTimeout(() => {
          this.$refs.eventCode.getSelectList();
        }, 100);
      }
    },
    protocolClassChange() {
      this.form.componentCode = '';
      this.form.eventCode = '';
      this.form.eventName = '';
      setTimeout(() => {
        this.$refs.componentCode.getSelectList();
        this.$refs.eventCode.getSelectList();
      }, 20);
    },
    langCodeChange() {
      setTimeout(() => {
        this.$refs.componentCode.getSelectList();
      }, 20);
    },
    closeDialog() {
      this.visible = false;
    },
    create() {
      const retData = this.getReqData();
      this.$postJSON(apis.eventAdd, retData, true).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_add_success'),
        });
        this.$emit('add');
        this.closeDialog();
      });
    },
    save() {
      const retData = this.getReqData();
      this.$postJSON(apis.eventUpdate, retData, true).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_edit_success'),
        });
        this.$emit('edit');
        this.closeDialog();
      });
    },
    getReqData() {
      const ret = { ...this.form };
      const componentCode = this.form.componentCode;
      const componentNode = this.componentCodeList.find((item) => item.componentCode === componentCode);
      if (!componentNode) {
        // 匹配不成清空 修复旧数据问题
        this.form.componentCode = '';
        this.form.componentName = '';

        // 直接返回 null 表示验证失败
        return null;
      }
      ret.componentName = componentNode.componentName;
      return ret;
    },
    async onConfirm() {
      // 先进行表单验证
      let isValid = false;
      await this.$refs.form.validate((valid) => {
        isValid = valid;
      });

      if (!isValid) {
        return;
      }

      // 验证 componentNode 是否存在
      const retData = this.getReqData();
      if (!retData) {
        // 由于 getReqData 内部已经清空了 componentCode，现在再次验证以显示错误信息
        await this.$refs.form.validateField('componentCode');
        return;
      }

      await Promise.all([
        this.$refs.dmsEventIcon.submit(),
        this.$refs.dmsDisposalCustomer.submit(),
        this.$refs.dmsDisposalTechnician.submit()
      ]);

      if (this.model.type === 'add') {
        this.create();
      } else {
        this.save();
      }
    },
    init() {
      if (this.model.type === 'edit') {
        const eventId = this.model.data.eventId;
        this.$getJSON(apis.eventInfo, {
          eventId,
        }).then((res) => {
          this.$setFormatData(this.form, res.data);

          setTimeout(() => {
            this.$refs.componentCode.getSelectList();
          }, 20);

          // setTimeout(() => {
          //   // const curProduct = this.$refs.product.getSelectedNode();
          //   // this.curProductSn = curProduct.productCode;

          //   this.productQuery = {
          //     productCode: this.form.productCode,
          //   };

          //   this.form.componentCode = this.form.componentCode;
          //   // 更新请求数据，其他更新树方式无法解决params缓存问题(params缓存上一次的变更)
          //   this.componentSelectKey = Math.random();

          //   this.updateEventCodeSel();
          // }, 100);
        });
      }
    },
  },
};
</script>

<style lang="scss">
.event-item-dialog {
  .title {
    color: #35405b;
    font-size: 14px;
    margin-bottom: 18px;
    font-weight: bold;
  }
  .label-box {
    margin-top: 1px;
    line-height: 31px;
    background: rgba(245, 245, 245, 1);
    min-width: 90px;
    height: 31px;
    text-align: center;
    color: #262626;
    font-size: 12px;
    padding: 0 10px;
    margin-left: 6px;
  }

  .content {
    display: flex;
    .event-msg {
      padding-right: 15px;

      .single-img {
        width: 180px;
        height: 180px;
      }
    }
    .handle-file {
      padding-left: 15px;
      border-left: 1px solid rgb(242, 243, 251);
    }
  }
}
</style>
